export default __webpack_public_path__ + "static/media/webIcon.cbd9122f.svg";